import { BRAND } from "../data/site";

const parts = ["Quality", "Efficiency", "Trust", "That's 101"];

export const Marquee = () => {
  const row = [...parts, ...parts, ...parts];
  return (
    <div data-testid="marquee" className="overflow-hidden border-y border-border bg-obsidian py-8">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {[0, 1].map((g) => (
          <div key={g} className="flex items-center">
            {row.map((p, i) => (
              <span key={`${g}-${i}`} className="flex items-center">
                <span className="font-display text-5xl md:text-7xl text-outline px-8">
                  {p}
                </span>
                <span className="text-ember text-3xl md:text-5xl">✦</span>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
